<template>
    <div class="contenedor-main-grafica-avance-fisico">
      <v-card
      flat>
        <v-card-actions
        >
          <v-spacer></v-spacer>
          <v-btn
          outlined
          @click="generarPdfGraficaAvanceFisico()"
          :loading="generandoPdfGraficaAvanceFisico"

          >
          <v-icon left> fa-file-pdf </v-icon>
            PDF
          </v-btn>
        </v-card-actions>
      </v-card>
        <grafica-avance-fisico
            :idContrato="idContrato"
            @mostrarGrafica="mostrarGrafica">
        </grafica-avance-fisico>
    </div>
</template>
<script>
import GraficaAvanceFisico from '@/components/administracion/ejecucion/graficaavancefisico/graficaAvanceFisico.vue';
import mixDescargaGraficaAvanceFisico from './mixDescargaGraficaAvanceFisico';

export default {
  name: 'MainGraficaAvanceFisico',
  props: {

  },
  data() {
    return {
      generandoPdfGraficaAvanceFisico: false,
      idContrato: this.$route.params.idContrato,
      activarMostrarGrafica: false,
    };
  },
  components: {
    GraficaAvanceFisico,
  },
  mixins: [
    mixDescargaGraficaAvanceFisico,
  ],

};
</script>
